module.exports = __webpack_public_path__ + "img/0.5dbd8f03.jpg";